// import { createClient } from '@supabase/supabase-js';

// Temporary mock Supabase client for development
// const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://dummy.supabase.co';
// const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'dummy-key';

// Mock Supabase client for development
export const supabase = {
  auth: {
    getSession: async () => ({ data: { session: null }, error: null }),
    onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } })
  },
  storage: {
    from: (bucket: string) => ({
      upload: async (path: string, file: File) => {
        console.log(`Mock Supabase storage upload to ${bucket}/${path}:`, file.name);
        return { error: null };
      }
    })
  },
  from: (table: string) => ({
    insert: async (data: any) => {
      console.log(`Mock Supabase insert into ${table}:`, data);
      return { error: null };
    }
  })
};

// Uncomment this when you have real Supabase credentials
// export const supabase = createClient(supabaseUrl, supabaseAnonKey);
